import { Component, OnInit } from "@angular/core";
import { PoDynamicViewField, PoModule } from "@po-ui/ng-components";
import { ActivatedRoute,Router } from "@angular/router";
import { ClientesViewService } from "../clientes-view/clientes-view.service";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-clientes-view",
  templateUrl: "./clientes-view.component.html",
  styleUrls: ["./clientes-view.component.css"],
  standalone: false,
})
export class ClientesViewComponent implements OnInit {
  private prosprectId: String;
  employee: Array<any>

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private clientesViewService: ClientesViewService
  ) {
    this.route.params.subscribe(params => (this.prosprectId = params["id"]));
  }

  ngOnInit() {
    this.clientesViewService
      .getclientess(this.prosprectId)
      .subscribe(response => {
        this.employee = response;
      });
  }

  fields: Array<PoDynamicViewField> = [
    { property: "id",    gridColumns: 4, divider:"Inf. Básicas" },
    { property: "status", gridColumns: 4 },
    { property: "codigo", gridColumns: 4 },
    { property: "loja", gridColumns: 4 },
    { property: "nome", gridColumns: 4 },
    { property: "nomefantasia", gridColumns: 4 },
    { property: "tipo", gridColumns: 4 },
    { property: "cgc", label: "CGC", gridColumns: 4 },
    { property: "inscr", gridColumns: 4 },
    { property: "contato", gridColumns: 4, divider:"Contato" },
    { property: "email", gridColumns: 4 },
    { property: "ddd", gridColumns: 4 },
    { property: "telefone", gridColumns: 4 },
    { property: "cep", gridColumns: 4 , divider:"Endereço"},
    { property: "endereco", gridColumns: 4 },
    { property: "bairro", gridColumns: 4 },
    { property: "municipio", gridColumns: 4 },
    { property: "uf", gridColumns: 4 }
  ];

  cancel(){
    this.router.navigate(["/clientes-list"]);
  }

}
